// Angular
import { Component, OnInit } from '@angular/core';
// services
import { AuthenticationService } from 'src/app/services';

@Component({
    selector: 'app-profile-section',
    templateUrl: './profile-section.component.html',
    styleUrls: ['./profile-section.component.scss'],
    standalone: false
})
export class ProfileSectionComponent implements OnInit {
    appName: string;
    routes: any;
    user: any;
    user$: any;
    profileOpen: boolean = null;

    constructor(public AuthenticationService: AuthenticationService) {}

    ngOnInit(): void {
        this.AuthenticationService.getUser().subscribe((next: any) => {
            this.user = { ...next };
        });
    }
}
